import PropTypes from "prop-types";

import ActivitiesDropdown from "../../../Reports/components/Leaderboards/ActivitiesDropdown";
import { LeadAssignInfo } from "./shared";

const LeadAssignTypeOptions = Object.entries(LeadAssignInfo).map(([key, value]) => ({
  value: key,
  label: value.pretty,
}));

const LeadAssignType = ({ assignType, setAssignType, setFallback }) => {
  const assignTypeOption = LeadAssignTypeOptions.find(({ value }) => value === assignType);

  const onChange = (val) => {
    setAssignType(val);
    setFallback("voicemail");
  };

  return (
    <div className="tw-flex tw-flex-col tw-bg-[#FAFAFA] tw-rounded-8px tw-border-[1px] tw-border-[#EBEBEB] tw-border-solid tw-p-16px tw-gap-16px">
      <div className="tw-flex tw-flex-row tw-gap-8px tw-text-14px tw-text-gray-75">
        <span>Assign leads via</span>
        <ActivitiesDropdown
          activity={assignTypeOption}
          onActivityChosen={onChange}
          options={LeadAssignTypeOptions}
        />
      </div>
      <div className="tw-text-12px tw-text-gray-50">{LeadAssignInfo[assignType].description}</div>
    </div>
  );
};

LeadAssignType.propTypes = {
  assignType: PropTypes.string.isRequired,
  setAssignType: PropTypes.func.isRequired,
  setFallback: PropTypes.func.isRequired,
};

export default LeadAssignType;
